import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/lib/LanguageContext";

const AirtableTemplateSection = () => {
  const { t } = useLanguage();

  return (
    <section className="max-w-7xl mx-auto px-6 py-24">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="glass-card rounded-2xl overflow-hidden max-w-4xl mx-auto"
      >
        <div className="grid md:grid-cols-2 gap-0">
          {/* Left: Video / Image placeholder */}
          <div className="bg-white/[0.03] flex items-center justify-center min-h-[320px] border-r border-white/5">
            <div className="text-center p-8">
              <div className="w-20 h-20 rounded-2xl bg-yellow-400/10 flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-yellow-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="5 3 19 12 5 21 5 3" />
                </svg>
              </div>
              <p className="text-white/40 text-sm">{t("airtable.videoSoon")}</p>
            </div>
          </div>

          {/* Right: Description */}
          <div className="p-8 flex flex-col justify-center">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="bg-yellow-400/10 text-yellow-400 text-xs font-bold px-3 py-1 rounded-full">
                {t("airtable.badge")}
              </span>
            </div>
            <h3
              className="font-bold text-2xl text-white mb-3"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {t("airtable.title")}
            </h3>
            <p className="text-white/60 mb-6 leading-relaxed">
              {t("airtable.desc")}
            </p>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-white/70 text-sm">
                <CheckCircle2 className="w-4 h-4 text-green-400 flex-shrink-0" />
                {t("airtable.feature1")}
              </li>
              <li className="flex items-center gap-2 text-white/70 text-sm">
                <CheckCircle2 className="w-4 h-4 text-green-400 flex-shrink-0" />
                {t("airtable.feature2")}
              </li>
              <li className="flex items-center gap-2 text-white/70 text-sm">
                <CheckCircle2 className="w-4 h-4 text-green-400 flex-shrink-0" />
                {t("airtable.feature3")}
              </li>
            </ul>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default AirtableTemplateSection;
